import React from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader/index'

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/LocalHospital";
import GridContainer from "components/Grid/GridContainer.jsx";
import TagsInput from "react-tagsinput";
import api from "../../api/Api";
import Permissions from '../../util/globalPermissions';
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Tooltip from "@material-ui/core/Tooltip";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    clinicmaster_id,
    getClinicUserId
} from '../../util/globalHelper';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

class Tests extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,//
            element: "",//
            api_status: "",//
            read: false,
            alert: null,
            clickedId: "",
            clinicsData: null,
            clinicmaster_id: null,
            patientList: null,
            clinicMasterList: null,
            redirect: false,
            redirectOne: false,
            redirectAdd: false,
            loading: true,
            selectedDoctorId: "",
            data: null
        };
        this.handleTags = this.handleTags.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    handleTags(regularTags) {
    }


    CallReadApi = () => {
        api.getTests({})
            .then(json => {
                this.setState({data: json.data.data}, () => {
                    this.setState({
                        data: this.state.data.map(item => {
                            // patientList: this.state.data.data.map(item => {
                            return {
                                "_id": item._id,
                                "name": item.master_test_id ? item.master_test_id.name : "-",
                                "description": item.master_test_id ? item.master_test_id.description : "-",
                                "clinic": item.clinic_id ? item.clinic_id.name : "-",
                                "total": item.total,
                                "discounted_price": item.discounted_price,
                            }
                        })
                    })
                })
            });
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}});
    };

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : "",

        };

        this.setState({data: null, patientList: null});
        api.getTests(postBody).then(json => {
            this.setState({data: json.data.data}, () => {
                this.setState({
                    data: this.state.data.map(item => {
                        // patientList: this.state.data.data.map(item => {
                        return {
                            "_id": item._id,
                            "name": item.master_test_id ? item.master_test_id.name : "-",
                            "description": item.master_test_id ? item.master_test_id.description : "-",
                            "clinic": item.clinic_id ? item.clinic_id.name : "-",
                            "total": item.total,
                            "discounted_price": item.discounted_price,
                        }
                    })
                })
            })
        });
    }

    componentDidMount() {
        this.CallReadApi();
        this.setState({clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()})
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    render() {
        const {data, clinicMasterList, clinicsData, patientList} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }

        const {classes} = this.props;
        if (this.state.clinicMasterList)
            return (
                <div>

                    {this.state.alert}

                    <Grid container>
                        {
                            // mappingUI(Permissions.AddDoctor) ?
                            <GridItem xs={12} sm={12} md={2}>
                                <NavLink to={dashboardRouter("/tests/add")}>
                                    <Button block color="warning">
                                        <Icon>add</Icon>
                                        <span style={{paddingLeft: 10}}>ADD NEW</span>
                                    </Button></NavLink>
                            </GridItem>
                            // : null
                        }
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Tests</h4>
                                                <p className={classes.cardCategoryWhite}>
                                                    List of all Tests
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                    <span>
                                               <GridContainer>

                                    < GridItem xs={12} sm={6} md={6}>
                                    </GridItem>
                                    < GridItem xs={12} sm={6} md={6}>
                                        {isClinicMasterOrClinic() === "" ? <FormControl
                                            fullWidth>
                                            <InputLabel
                                                htmlFor="clinicmaster_id">
                                                Clinic Master
                                            </InputLabel>
                                            <Select
                                                value={this.state.clinicmaster_id}
                                                onChange={this.onChangeSelect}
                                                inputProps={{
                                                    name: "clinicmaster_id",
                                                    id: "clinicmaster_id"
                                                }}>
                                                <MenuItem
                                                    disabled>
                                                    Select Clinic
                                                </MenuItem>
                                                {clinicMasterList.map((x) => {
                                                    return <MenuItem key={Math.random()}
                                                                     style={{height: "1.8em"}}
                                                                     value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                })}
                                            </Select>
                                        </FormControl> : null}
                                        <br/>
                                        {isClinicMasterOrClinic() === "" && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                            <FormControl
                                                fullWidth>
                                                <InputLabel
                                                    htmlFor="clinic_id">
                                                    Clinic
                                                </InputLabel>
                                                <Select
                                                    value={this.state.clinic_id}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "clinic_id",
                                                        id: "clinic_id"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                    >
                                                        Select Clinic
                                                    </MenuItem>
                                                    {clinicsData.map((x) => {
                                                        return <MenuItem key={Math.random()}
                                                                         style={{height: "1.8em"}}
                                                                         value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            : null}
                                    </GridItem></GridContainer>
                                    </span>
                                </CardHeader>
                                <CardBody>
                                    <div>

                                    </div>
                                    {data ?
                                        <ReactTable
                                            data={data}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                                String(row[filter.id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Test Name",
                                                            accessor: "name",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p style={{cursor: 'pointer'}}>
                                                                            {data[index].name}
                                                                        </p>
                                                                    </div>
                                                                ),
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["name"]}),
                                                            filterAll: true
                                                        },
                                                        {
                                                            Header: "Clinic",
                                                            accessor: "clinic",
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["clinic"]}),
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].clinic ? data[index].clinic : "-"}</p>
                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false
                                                        },
                                                        {
                                                            Header: "Description",
                                                            accessor: "description",
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["description"]}),
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {data[index] ? data[index].description : "No description"}
                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false
                                                        }, {
                                                            Header: "Price",
                                                            accessor: "total",
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["total"]}),
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index] ? data[index].total : "-"}</p>
                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false
                                                        }, {
                                                            Header: 'Actions',
                                                            id: 'request_state',
                                                            filterable: false,
                                                            sortable: false,
                                                            maxWidth: 160,
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        {
                                                                            <NavLink
                                                                                to={dashboardRouter(`/tests/view/${data[index]._id}`)}><Tooltip
                                                                                id="tooltip-top"
                                                                                title="View"
                                                                                placement="bottom"
                                                                                classes={{tooltip: classes.tooltip}}>
                                                                                <Button type="button" color="info"
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            marginLeft: '10%'
                                                                                        }}>
                                                                                    <Icon
                                                                                        style={{fontSize: 20}}>info</Icon>
                                                                                </Button>
                                                                            </Tooltip></NavLink>}
                                                                        {
                                                                            <NavLink
                                                                                to={dashboardRouter(`/tests/update/${data[index]._id}`)}><Tooltip
                                                                                id="tooltip-top"
                                                                                title="Edit"
                                                                                placement="bottom"
                                                                                classes={{tooltip: classes.tooltip}}>
                                                                                <Button type="button" color="success"
                                                                                        style={{
                                                                                            padding: 8,
                                                                                            marginLeft: '5%'
                                                                                        }}>
                                                                                    <Icon
                                                                                        style={{fontSize: 20}}>edit</Icon>
                                                                                </Button>
                                                                            </Tooltip></NavLink>}
                                                                    </div>
                                                                )
                                                        }
                                                    ]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : null}
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

}

Tests.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(sweetAlertStyle)(Tests);



// WEBPACK FOOTER //
// ./src/components/Tests/Tests.jsx